module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "height": "100%"
    },
    style: ({
      height: _vm.menuHeight
    }),
    attrs: {
      "span": 4
    }
  }, [_c('el-menu', {
    staticStyle: {
      "height": "100%",
      "border-radius": "0 !important"
    },
    attrs: {
      "default-active": _vm.activedIndex,
      "default-openeds": ['1-1', '1-2', '1-3', '1-4'],
      "theme": "dark",
      "router": true
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "1-1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("账号管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/settings/company"
    }
  }, [_vm._v("企业管理")]), _vm._v(" "), (_vm.me.rname === 'ROLE_ADMIN') ? _c('el-menu-item', {
    attrs: {
      "index": "/settings/user"
    }
  }, [_vm._v("用户管理")]) : _vm._e()], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "1-2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("采集平台管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/settings/device"
    }
  }, [_vm._v("设备管理")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "1-3"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("能效管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/settings/energy-level"
    }
  }, [_vm._v("阶梯时间管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/settings/energy-price"
    }
  }, [_vm._v("费率管理")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "1-4"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("其他管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/settings/city"
    }
  }, [_vm._v("城市管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/settings/notice"
    }
  }, [_vm._v("通知管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/settings/device-status"
    }
  }, [_vm._v("离线统计")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/settings/service-log"
    }
  }, [_vm._v("服务记录")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "height": "100%",
      "padding": "20px"
    },
    attrs: {
      "span": 20
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-419e8368"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SettingsLayout.vue
// module id = 1302
// module chunks = 1